import React from 'react';
import FilterSkeleton from '@components/organisms/catalog/components/skeleton-components/filter-skeleton/filter-skeleton';

const FilterLoadingsState = () => {
  return (
    <>
      {Array.from(Array(10).keys()).map((key, index) => (
        <FilterSkeleton
          key={key}
          index={index}
        />
      ))}
    </>
  );
};

export default FilterLoadingsState;
